import styled from "styled-components";

const DetailsTableButtonsDivStyled = styled.div`
  float: right;
  padding-top: 0px;
  margin-left: 10px;
`;

export default DetailsTableButtonsDivStyled;
